import { Link } from "react-router-dom";

export default function TechHero({
  kicker = "Global-Grade Engineering",
  title = "Advanced Tech, Crafted for Scale",
  titleAs = "h2",
  subtitle = "3D-inspired visuals, secure architecture, and lightning-fast delivery designed to compete with top-tier IT brands.",
  ctaText = "Start a project",
  ctaLink = "/contact",
}) {
  const isInternalCta = typeof ctaLink === "string" && ctaLink.startsWith("/");
  const TitleTag = titleAs;

  return (
    <section className="tech-hero">
      <div className="tech-hero__grid" aria-hidden="true" />
      <div className="tech-hero__content">
        <p className="tech-hero__kicker">{kicker}</p>
        <TitleTag className="tech-hero__title">{title}</TitleTag>
        <p className="tech-hero__subtitle">{subtitle}</p>
        <div className="tech-hero__actions">
          {isInternalCta ? (
            <Link to={ctaLink} className={`btn-gold ${ctaLink === '/book-consultation' ? 'consultation-booking' : ''}`}>{ctaText}</Link>
          ) : (
            <a href={ctaLink} className={`btn-gold ${ctaLink === '/book-consultation' ? 'consultation-booking' : ''}`}>{ctaText}</a>
          )}
          <Link to="/portfolio" className="link-gold">View work</Link>
        </div>
      </div>
      <div className="tech-hero__visual" aria-hidden="true">
        <div className="tech-orbital">
          <div className="tech-core" />
          <div className="tech-orbit orbit-1" />
          <div className="tech-orbit orbit-2" />
          <div className="tech-orbit orbit-3" />
          <div className="tech-satellite sat-1" />
          <div className="tech-satellite sat-2" />
          <div className="tech-satellite sat-3" />
        </div>
      </div>
    </section>
  );
}
